import { AdminDealModal } from "@components/admin-deal-modal";
import { Block } from "@components/block";
import { Button } from "@components/button";
import { Input } from "@components/input";
import { Config, DoubleText, Table } from "@components/table";
import { useBoolState } from "@hooks/use-bool-state";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import styles from "./deals.module.scss";
import { CustomSelect } from "@components/select";
import { useAdminOrders } from "@features/admin/order";
import { AdminOrder, AdminOrdersRequest } from "@features/admin/order/api";
import { formatDate, formatTime } from "@helpers/date";
import { formatRubles, formatUsdt } from "@helpers/format";
import { usePagination } from "@hooks/use-pagination";
import { useUrlFilters } from "@hooks/useUrlFilters";
import { getFilterParamFromQuery } from "@helpers/utilities";
import { EllipsisText } from "@components/ellipsis-text";
import { useWebSocket } from "@request/useWebsocket";
import { WebsocketUpdateType } from "@request/websocket";

const adminDealConfig: Config<AdminOrder> = [
  {
    label: "ID сделки",
    source: "id",
    renderComponent: (item) => <EllipsisText text={item} copy />,
  },
  {
    label: "Invid",
    source: "invid",
    renderComponent: (item) => <EllipsisText text={item} copy />,
  },
  {
    label: "Статус",
    source: "status",
  },
  {
    label: "Дата Время",
    source: "created_at",
    renderComponent: (data) => (
      <DoubleText
        text={formatTime(new Date(data))}
        subText={formatDate(new Date(data))}
      />
    ),
  },
  {
    label: "Сумма заявки",
    source: "order_start_amount",
    renderComponent: (data, item) => (
      <DoubleText
        text={formatUsdt(item.order_start_amount_usdt)}
        subText={formatRubles(data)}
      />
    ),
  },
  {
    label: "Сумма мерча",
    source: "merchant_amount",
    renderComponent: (data, item) => (
      <DoubleText
        text={formatUsdt(item.merchant_amount_usdt)}
        subText={formatRubles(data)}
      />
    ),
  },
  {
    label: "Итоговая сумма",
    source: "order_final_amount",
    renderComponent: (data, item) => (
      <DoubleText
        text={formatUsdt(item.order_final_amount_usdt)}
        subText={formatRubles(data)}
      />
    ),
  },
  {
    label: "Email трейдер",
    source: "trader_email",
  },
  {
    label: "Email мерч",
    source: "merchant_login",
  },
];

export const AdminDealsPage = () => {
  const [isModalOpen, showModal, hideModal] = useBoolState(false);
  const [currentDeal, setCurrentDeal] = useState<AdminOrder>();
  const { control, handleSubmit } = useForm<AdminOrdersRequest>();
  const { page, limit, setPage, setLimit } = usePagination(100);
  const { setParams } = useUrlFilters();
  const { state, getAdminOrders } = useAdminOrders();
  const { lastMessage } = useWebSocket();

  useEffect(() => {
    if (lastMessage && lastMessage.type == WebsocketUpdateType.Withdrawal) {
      const status = getFilterParamFromQuery("status");
      const merchant_id = getFilterParamFromQuery("merchant_id");
      const trader_id = getFilterParamFromQuery("trader_id");
      getAdminOrders({ limit, page, status, merchant_id, trader_id });
    }
  }, [lastMessage, limit, page]);
  useEffect(() => {
    const status = getFilterParamFromQuery("status");
    const merchant_id = getFilterParamFromQuery("merchant_id");
    const trader_id = getFilterParamFromQuery("trader_id");
    getAdminOrders({ limit, page, status, merchant_id, trader_id });
  }, [getAdminOrders, limit, page]);

  const onDealClick = (item: AdminOrder) => {
    showModal();
    setCurrentDeal(item);
  };
  const options = [
    { text: "Completed", value: "completed" },
    { text: "Canceled", value: "canceled" },
    { text: "Dispute open", value: "dispute_open" },
  ];

  const platformOption = [
    { text: "С платформы", value: "true" },
    { text: "Не с платформы", value: "false" },
  ];

  const submit = (data: AdminOrdersRequest) => {
    setParams(data);
    getAdminOrders({ ...data, limit: 100, page: 1 });
    setLimit(100);
  };
  return (
    <Block>
      <form className={styles.filter} onSubmit={handleSubmit(submit)}>
        <Input
          name="trader_id"
          control={control}
          placeholder="trader_id"
          clearable
        ></Input>
        <Input
          name="merchant_id"
          control={control}
          placeholder="merchant_id"
          clearable
        ></Input>
        <CustomSelect
          name="status"
          control={control}
          options={options}
          placeholder="Поиск по статусу"
          styles={{ width: "200px" }}
          clearable
        ></CustomSelect>
        <CustomSelect
          name="platform"
          control={control}
          options={platformOption}
          placeholder="Заявка платформы"
          styles={{ width: "200px" }}
          clearable
        ></CustomSelect>
        <Button className={styles.btn}>Search</Button>
      </form>
      <Table
        config={adminDealConfig}
        data={state?.orders}
        loading={state.loading}
        setPage={setPage}
        setLimit={setLimit}
        page={page}
        limit={limit}
        limits={[100, 200, 300]}
        totalCount={state.count}
        onRowClick={onDealClick}
      ></Table>
      {currentDeal && (
        <AdminDealModal
          isModalOpen={isModalOpen}
          hideModal={hideModal}
          data={currentDeal}
        />
      )}
    </Block>
  );
};
